<div class="padding">
  @if (reusableParties.length > 0) {
    <div class="flex-container">
      <mat-form-field class="flex-item-6" appearance="outline">
        <mat-select [placeholder]="'common.labels.reusableParty' | transloco" [(ngModel)]="_selectedReusablePartyID" (selectionChange)="reusablePartySelected()">
          @for (party of reusableParties; track party; let i = $index) {
            <mat-option [value]="party.id!"
              [attr.data-testid]="'existing-party-option-' + i">
              {{ party.fullName! }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  <form [formGroup]="partyDetails">
    <div class="flex-container">
      @if (!uiConfiguration.individualOnly) {
      <div class="flex-item form-field">
        <mat-radio-group [formControlName]="'partyTypeID'"
          [attr.aria-label]="'common.parties.individualOrBusiness' | transloco">
          <mat-radio-button data-testid="individual-selection-radio-button" class="radio-button"
          [value]="individualPartyType">{{ 'common.parties.individual.' + partyTypeKey | transloco }}</mat-radio-button>
          <mat-radio-button data-testid="business-selection-radio-button" class="radio-button"
            [value]="businessPartyType">{{ 'common.parties.business.' + partyTypeKey | transloco }}</mat-radio-button>
        </mat-radio-group>
      </div>
      }
      @if (uiConfiguration.showEstate && displayIndividualFields) {
        <div class="flex-item form-field">
          <mat-checkbox [formControlName]="'isEstate'" data-testid="is-estate-checkbox">
            {{ 'common.labels.estate' | transloco }}
          </mat-checkbox>
        </div>
      }
    </div>

    @if (displayIndividualFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
            <input matInput [libAutoCapitalize]="uiConfiguration.autoCapitalizeFields" [formControlName]="'firstName'" data-testid="first-name-field" [placeholder]="'common.labels.firstName' | transloco" />
          </mat-form-field>
          <lib-error-bubble [control]="partyDetails.controls['firstName']"
          [message]="firstNameError$"></lib-error-bubble>
        </div>
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
            <input matInput [libAutoCapitalize]="uiConfiguration.autoCapitalizeFields" [formControlName]="'middleName'" data-testid="middle-name-field" [placeholder]="'common.labels.middleName' | transloco" />
          </mat-form-field>
          <lib-error-bubble [control]="partyDetails.controls['middleName']"
          [message]="middleNameError$"></lib-error-bubble>
        </div>
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
            <input matInput [libAutoCapitalize]="uiConfiguration.autoCapitalizeFields" [formControlName]="'lastName'" data-testid="last-name-field" [placeholder]="'common.labels.lastName' | transloco" />
          </mat-form-field>
          <lib-error-bubble [control]="partyDetails.controls['lastName']"
          [message]="lastNameError$"></lib-error-bubble>
        </div>
        @if (uiConfiguration.showGeneration && generations.length > 0) {
          <div
            class="validated-form-field-container flex-container">
            <mat-form-field appearance="outline" class="form-field flex-item">
              <mat-label>{{ 'common.labels.generation' | transloco }}</mat-label>
              <mat-select formControlName="generationID" [placeholder]="'common.labels.generation' | transloco" data-testid="generation-dropdown">
                <mat-option [value]="null">{{ 'common.labels.none' | transloco }}</mat-option>
                @for (gen of generations; track gen) {
                  <mat-option [value]="gen.value"
                    [attr.data-testid]="'generation-option-' + gen.value">
                    {{ gen.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <lib-error-bubble [control]="partyDetails.controls['generationID']"
            [message]="generationError$"></lib-error-bubble>
          </div>
        }
      </div>
    }
    @if (displayIndividualFields && uiConfiguration.showDateOfBirth) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.dateOfBirth' | transloco }}</mat-label>
            <input matInput [matDatepicker]="dateOfBirth" [formControlName]="'dateOfBirth'" data-testid="date-of-birth-field"
              [placeholder]="'common.labels.datePlaceholder' | transloco" />
            <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
            <mat-datepicker #dateOfBirth></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="partyDetails.controls['dateOfBirth']"
          [message]="dateOfBirthError$"></lib-error-bubble>
        </div>
      </div>
    }
    @if (displayBusinessFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
            <input matInput [libAutoCapitalize]="uiConfiguration.autoCapitalizeFields" [formControlName]="'busName'" data-testid="business-name-field" [placeholder]="'common.labels.businessName' | transloco" />
          </mat-form-field>
          <lib-error-bubble [control]="partyDetails.controls['busName']"
          [message]="busNameError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.contactDetailsConfiguration) {
      <form [formGroup]="contactDetails">
        @if (uiConfiguration.contactDetailsConfiguration.showEmail) {
          <div class="flex-container">
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.email' | transloco }}</mat-label>
                <input matInput [libAutoLowercase]="uiConfiguration.contactDetailsConfiguration.autoLowercaseEmail"
                  [libAutoCapitalize]="!uiConfiguration.contactDetailsConfiguration.autoLowercaseEmail && uiConfiguration.contactDetailsConfiguration.autoCapitalizeFields" [formControlName]="'email'" data-testid="email-field" [placeholder]="'common.labels.email' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="contactDetails.controls['email']"
              [message]="emailError$"></lib-error-bubble>
            </div>
          </div>
        }
        @if (uiConfiguration.contactDetailsConfiguration.showPhoneNumber || uiConfiguration.contactDetailsConfiguration.showFaxNumber) {
          <div
            class="flex-container">
            @if (uiConfiguration.contactDetailsConfiguration.showPhoneNumber) {
              <div
                class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                  <mat-label>{{ 'common.labels.phoneNumber' | transloco }}</mat-label>
                  <input matInput [formControlName]="'phoneNumber'" data-testid="phoneNumber-field" placeholder="111-222-3333">
                </mat-form-field>
                <lib-error-bubble [control]="contactDetails.get('phoneNumber')!"
                [message]="phoneNumberError$"></lib-error-bubble>
              </div>
            }
            @if (uiConfiguration.contactDetailsConfiguration.showFaxNumber) {
              <div
                class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                  <mat-label>{{ 'common.labels.faxNumber' | transloco }}</mat-label>
                  <input matInput [formControlName]="'faxNumber'" data-testid="faxNumber-field" placeholder="111-222-3333">
                </mat-form-field>
                <lib-error-bubble [control]="contactDetails.get('faxNumber')!"
                [message]="faxNumberError$"></lib-error-bubble>
              </div>
            }
          </div>
        }
        @if ((displayIndividualFields && uiConfiguration.contactDetailsConfiguration.showIndividualAddress) ||
          (displayBusinessFields && uiConfiguration.contactDetailsConfiguration.showBusinessAddress)) {
          <lib-address-form
            [address]="$safeNavigationMigration(party.contactDetails?.address)"
          [uiConfiguration]="uiConfiguration.contactDetailsConfiguration"></lib-address-form>
        }
      </form>
    }
    <!-- Navigation buttons -->
    <div class="flex-container padding-top">
      @if (showClearButton) {
        <button mat-raised-button (click)="clearFields()" class="padding-sides flex-item form-field previous-button"
          [attr.aria-label]="'common.buttons.clearFields' | transloco" data-testid="clear-fields-button">
          {{ 'common.buttons.clearFields' | transloco }}
        </button>
      }
      @if (showDeleteButton) {
        <button
          mat-raised-button
          (click)="removeParty()"
          class="margin-sides-15 flex-item form-field previous-button"
          [attr.aria-label]="'common.parties.delete.' + partyTypeKey | transloco"
          color="warn"
          data-testid="delete-party-button"
          >
          {{ 'common.parties.delete.' + partyTypeKey | transloco }}
        </button>
      }

      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>

      @if (showSaveButton) {
        <button mat-raised-button (click)="saveParty()" color="primary"
          class="padding-sides flex-item form-field" [attr.aria-label]="'common.parties.save.' + partyTypeKey | transloco" data-testid="save-party-button">
          {{ 'common.parties.save.' + partyTypeKey | transloco }}
        </button>
      }
      <!-- [class.spinner]="this.isSaving"
      [disabled]="this.isSaving" -->
    </div>
  </form>
</div>